module.exports = __webpack_public_path__ + "static/media/mobileScreenshot04.e3c9e832.jpg";